import * as models from './model';

export interface SubCategory {
    id: string;
    name: string;
    count: number;
    selected: boolean;
    sequence: number;
}
